const inputPhoneNumber = document.getElementById('tel');
const formatPhoneNumber = () => {
  inputPhoneNumber.addEventListener('blur', function (e) {
    let value = e.target.value;
    value = value.replace(/[０-９]/g, function (s) {
        // 文字コードを65248引いて半角に
        return String.fromCharCode(s.charCodeAt(0) - 65248);
      })
      .replace(/[^0-9]/g, '');
    e.target.value = value;
  });
};
formatPhoneNumber();
